import { MarketplaceListing } from './hooks/useListMarketplaceListings'

/** Live Platform icon (iconMediaRef); falls back to ES document icon. */
export const getMarketplaceListingDisplayIcon = (listing: MarketplaceListing): string | null => {
  const liveIcon = listing.listing?.icon
  if (liveIcon) {
    return liveIcon
  }
  return listing.icon || null
}
